<template>
  <div>
    <v-container fluid fill-height class="pa-0">
      <v-hover v-slot:default="{ hover }">
        <v-carousel
          :cycle="hover ? false : true"
          hide-delimiters
          :show-arrows="false"
          height="calc(95vh - 165px)"
          class="max-h70vh">
          <v-carousel-item
            v-for="(slide, i) in headerlist"
            :key="i"
            :lazy-src="require('../assets/default.jpg')"
            :src="slide.urlpic"
            class="max-h70vh">
            <v-container
              fill-height
              fluid
              pa-0 ma-0
              class="max-h70vh">
              <v-container class="pa-0">
                <v-layout
                  fill-height>
                  <v-flex
                    xs12
                    :align-self-end="!$vuetify.breakpoint.smAndDown"
                    :align-self-center="$vuetify.breakpoint.smAndDown">
                    <v-card
                      tile
                      color="transparent"
                      flat>
                      <v-card-text class="background-trans-style">
                        <div>
                          <h1 class="white--text text-md-h2 mb-5 title-page">{{ $t('title.coopcourse') }}</h1>
                          <h2 class="white--text text-md-h4 mb-5">
                            {{ $t('header.tagline') }}
                          </h2>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-container>
          </v-carousel-item>
        </v-carousel>
      </v-hover>
    </v-container>
    <v-container class="my-10">
      <v-row>
        <v-col cols="12" md="12">
          <v-row justify="center" class="black--text">
            <v-col cols="12" md="12">
              <h2 class="text-md-h4 font-weight-bold sub-title-page">
                {{ $t('title.coopcourse') }}
              </h2>
            </v-col>
            <v-col cols="12" md="12">
              <div v-if="$i18n.locale === 'en'">
                PNB has strong cooperation and partnership programs with educational institutions across the globe. Below are some of our international partners.
              </div>
              <div v-if="$i18n.locale === 'id'">
                PNB memiliki kerjasama yang kuat dan program kemitraan dengan lembaga pendidikan di seluruh dunia. Di bawah ini adalah beberapa mitra internasional kami.
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <v-img
                :src="require('../assets/coop-class.jpeg')">
              </v-img>
            </v-col>
            <v-col cols="12" md="6">
              <v-divider></v-divider>
              <div v-if="$i18n.locale === 'en'" class="mb-5">
                <v-expansion-panels tile flat focusable>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      L’Universite d’Angers France.
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      The cooperation developed through a mutual recognition to facilitate double degree program for both parties. Both parties recognized the achievement of the students and integrated with the welcoming university’s program. Politeknik Negeri Bali and L’Universite d’Angers have organized international joint conference.
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      École des ingénieurs de la Ville de Paris (EIVP)
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      EIVP has developed cooperation with PNB focusing on research internship in our civil engineering laboratory, exchange and double degree arrangement opportunities are open for both parties.
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      Windesheim University of Applied Sciences
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      Regular students’ exchange, joint research and community services have been done by both parties.
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      ROC Midden Nederland
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      Collaborative online international learning (Project based)
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      MSU Malaysia
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      MSU and PNB have initiated extension program, the participants study in PNB for three years, they will continue in MSU for one year for their bachelor, or two year for their  master degree.
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      NCUT Taiwan
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      Industrial academia program, where Indonesian students can work and study while doing their bachelor or master degree.
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      Raja Manggala University
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      Students and teaching faculties exchange
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      Sanming University, China
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      Students and teaching faculties exchange
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      TNO and the Dutch Government
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      TNO and PNB establish Renewable Energy Training Center.
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      SECO Switzerland
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      SECO and PNB establish Renewable Energy Skill Development.
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
              <div v-if="$i18n.locale === 'id'" class="mb-5">
                <v-expansion-panels tile flat focusable>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      L’Universite d’Angers France.
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      Kerjasama dikembangkan melalui saling pengakuan untuk memfasilitasi program gelar ganda bagi kedua belah pihak. Kedua belah pihak mengakui prestasi mahasiswa dan terintegrasi dengan program universitas penyambutan. Politeknik Negeri Bali dan L'Universite d'Angers telah menyelenggarakan konferensi internasional bersama.
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      École des ingénieurs de la Ville de Paris (EIVP)
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      EIVP telah mengembangkan kerjasama dengan PNB yang berfokus pada magang penelitian di laboratorium teknik sipil kami, peluang pertukaran dan pengaturan gelar ganda terbuka untuk kedua belah pihak.
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      Windesheim University of Applied Sciences
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      Pertukaran mahasiswa reguler, penelitian bersama dan pengabdian masyarakat telah dilakukan oleh kedua belah pihak.
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      ROC Midden Nederland
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      Pembelajaran internasional online kolaboratif (Berbasis proyek)
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      MSU Malaysia
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      MSU dan PNB telah memulai program ekstensi, peserta belajar di PNB selama tiga tahun, mereka akan melanjutkan di MSU selama satu tahun untuk sarjana, atau dua tahun untuk gelar master.
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      NCUT Taiwan
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      Program akademi industri, di mana mahasiswa Indonesia dapat bekerja dan belajar sambil menempuh pendidikan S1 atau S2.
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      Raja Manggala University
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      Pertukaran mahasiswa dan dosen
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      Sanming University, China
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      Pertukaran mahasiswa dan dosen
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      TNO and the Dutch Government
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      TNO dan PNB mendirikan Pusat Pelatihan Energi Terbarukan.
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      SECO Switzerland
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      SECO dan PNB membangun Pengembangan Keterampilan Energi Terbarukan.
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
              <v-btn
                :color="maincolor"
                class="white--text"
                :to="{ name: 'NewsDetail', query: { berita: 25 } }">
                {{ $t('button.enroll') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid fill-height class="py-10 min-height-pages bacground-maincolor">
      <v-container class="px-0 px-md-3">
        <v-row>
          <v-col cols="12" md="4">
            <v-card
              tile
              flat
              :to="{ name: 'Coursereg' }">
              <v-card-title class="font-weight-bold">
                <div>
                  {{ $t('title.regcourse') }}
                </div>
                <v-spacer></v-spacer>
                <v-icon
                  :color="maincolor">
                  mdi-open-in-new
                </v-icon>
              </v-card-title>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card
              tile
              flat
              :to="{ name: 'Courseint' }">
              <v-card-title class="font-weight-bold">
                <div>
                  {{ $t('title.intcourse') }}
                </div>
                <v-spacer></v-spacer>
                <v-icon
                  :color="maincolor">
                  mdi-open-in-new
                </v-icon>
              </v-card-title>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card
              tile
              flat
              :to="{ name: 'Coursecoop' }">
              <v-card-title class="font-weight-bold">
                <div>
                  {{ $t('title.coopcourse') }}
                </div>
                <v-spacer></v-spacer>
                <v-icon
                  :color="maincolor">
                  mdi-open-in-new
                </v-icon>
              </v-card-title>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card
              tile
              flat
              :to="{ name: 'Courserpl' }">
              <v-card-title class="font-weight-bold">
                <div>
                  {{ $t('title.rplcourse') }}
                </div>
                <v-spacer></v-spacer>
                <v-icon
                  :color="maincolor">
                  mdi-open-in-new
                </v-icon>
              </v-card-title>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card
              tile
              flat
              :to="{ name: 'Coursespe' }">
              <v-card-title class="font-weight-bold">
                <div>
                  {{ $t('title.specialcourse') }}
                </div>
                <v-spacer></v-spacer>
                <v-icon
                  :color="maincolor">
                  mdi-open-in-new
                </v-icon>
              </v-card-title>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <v-container class="my-10">
      <v-row>
        <v-col cols="12" md="12">
          <h2 class="text-md-h4 font-weight-bold sub-title-page">
            {{ $t('title.newsedu') }}
          </h2>
        </v-col>
      </v-row>
      <v-row v-if="newslist.length">
        <v-col
          class="d-flex"
          cols="12"
          md="4"
          v-for="(news, i) in newslist"
          :key="i">
          <v-card
            class="d-flex flex-column w100">
            <v-img
              class="white--text align-end flex-grow-0 flex-shrink-1"
              height="225px"
              :src="news.urlpic">
            </v-img>
            <v-card-subtitle>
              <h1 class="title font-weight-bold mb-3">
                <router-link class="text-decoration-none text-ellipsis--2"
                  :title="news.judul_berita"
                  :to="{ name: 'NewsDetail', query: { berita: news.id_berita } }">
                  {{ news.judul_berita }}
                </router-link>
              </h1>
              <div class="d-flex">
                <v-chip
                  class="mr-1"
                  color="deep-orange"
                  small
                  dark
                  :title="news.tgl_berita">
                  <v-icon left small>
                    mdi-update
                  </v-icon>
                  <timeago :datetime="news.tgl_berita"></timeago>
                </v-chip>
                <v-chip
                  class="mr-1"
                  color="primary"
                  small
                  dark>
                  <v-icon left small>
                    mdi-alpha-c-circle
                  </v-icon>
                  {{ news.cat_berita }}
                </v-chip>
                <v-spacer></v-spacer>
                <ShareNetwork
                  network="facebook"
                  :url="getRouteUrl('NewsDetail', { berita: news.id_berita })"
                  :title="news.judul_berita"
                  :description="news.prev_berita"
                  :quote="news.prev_berita"
                  hashtags="international,pnb,bali"
                  class="text-decoration-none d-inline mr-1">
                  <v-icon color="indigo">
                    mdi-facebook
                  </v-icon>
                </ShareNetwork>
                <ShareNetwork
                  network="whatsapp"
                  :url="getRouteUrl('NewsDetail', { berita: news.id_berita })"
                  :title="news.judul_berita"
                  :description="news.prev_berita"
                  :quote="news.prev_berita"
                  hashtags="international,pnb,bali"
                  class="text-decoration-none d-inline mr-1">
                  <v-icon color="green">
                    mdi-whatsapp
                  </v-icon>
                </ShareNetwork>
              </div>
            </v-card-subtitle>
            <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
              <div v-html="news.prev_berita"></div>
            </v-card-text>
            <v-card-actions v-if="false">
              <v-btn
                class="mx-2"
                fab
                depressed
                dark
                x-small
                :to="{ name: 'NewsDetail', query: { berita: news.id_berita } }">
                <v-icon dark>
                  mdi-arrow-right
                </v-icon>
              </v-btn>
              <span>{{ $t('button.readmore') }}</span>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="12">
          <v-btn
            large
            :color="maincolor"
            dark
            :to="{ name: 'News', query: { type: 'berita', category: 'pendidikan' } }"
            exact>
            {{ $t('button.othernews') }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="!newslist.length">
        <v-col cols="12" md="12">
          <div class="grey--text my-2">
            Berita pada kategori ini tidak ditemukan.
          </div>
        </v-col>
        <v-col cols="12" md="12">
          <v-btn
            large
            :color="maincolor"
            dark
            :to="{ name: 'News', query: { type: 'berita', category: 'pendidikan' } }"
            exact>
            {{ $t('button.othernews') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Coursecoop',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
    },
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
    },
    headers: [
      { text: 'Nama', value: 'nama_kerja' },
      { text: 'Deskripsi', value: 'deskripsi_kerja' },
      { text: 'Status', value: 'status_kerja' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    newslist: [],
    addjeniskerja: {
      nama_kerja: '',
      deskripsi_kerja: '',
      email: '',
      company: '',
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    paramberita: {
      search: '',
      limit: '',
      offset: '',
      lang: '',
      type: '',
      category: '',
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (!!v && v.length >= 8) || 'Min 8 characters',
      nik: (v) => (!!v && v.length >= 16) || 'Min 16 characters',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      },
    },
    tabdata: null,
    dmodal: {
      jeniskerja: false,
    },
    dmodaldata: {
      jeniskerja: null,
    },
    headerlist: [
      {
        id_berita: '',
        judul_berita: '',
        urlpic: require('./../assets/coop-class.jpeg'),
      },
    ],
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    this.getBerita();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  watch: {
    '$i18n.locale'(val) {
      if (val) {
        // console.log(val);
        this.updateLanguage();
      }
    },
  },
  methods: {
    getRouteUrl(nameroute, paramroute) {
      const props = this.$router.resolve({
        name: nameroute,
        query: paramroute,
      });
      // console.log(props);
      return this.baseurl + '' + props.href;
    },
    updateLanguage() {
      this.getBerita();
    },
    getBerita() {
      this.newslist = [];
      this.paramberita.lang = this.$i18n.locale;
      this.paramberita.limit = 6;
      this.paramberita.type = 'berita';
      this.paramberita.category = 'pendidikan';
      this.axios
        .get(
          this.api + '/public/berita',
          {
            params: this.paramberita,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              resdata.data.forEach((element) => {
                if (element.pic_berita) {
                  element.urlpic = this.api + '/upload/news/' + element.pic_berita;
                } else {
                  element.urlpic = require('../assets/default.jpg');
                }
                this.newslist.push(element);
              });
              // console.log(this.newslist);
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
